<script>
import TablePage from '../../../../components/table_page';
import Modal from '../../../../components/modal';
import Form from './form';

export default {
  name: 'specialty_store_list',
  extends: TablePage,
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        code: '',
      },
    };
  },
  components: {
    Modal,
    Form,
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      console.log('code0', code);
      const { approveStatus } = row;
      if (approveStatus && code === 'edit' && (approveStatus === '2' || approveStatus === '3')) { // 审批中或者通过不能编辑
        return false;
      }
      return true;
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      this.formConfig = {};
      this.formName = 'Form';
      if (val.code === 'add') {
        this.modalConfig.title = '新增';
        this.formConfig = {
          code: val.code,
          id: null,
        };
        this.openFull();
      } else if (val.code === 'edit') {
        this.modalConfig.title = '编辑';
        this.formConfig = {
          code: val.code,
          row,
        };
        this.openFull();
      } else if (val.code === 'view') {
        this.modalConfig.title = '查看';
        this.formConfig = {
          ...val,
          row,
          code: val.code,
        };
        this.openFull();
      }
    },
    // 删除操作
    // deleteClick({ row }) {
    //   const ids = row ? [row.id] : this.selection;

    //   const title = '此操作将永久删除此数据, 是否继续?';
    //   const url = '/mdm/mdmRoleController/delete';
    //   const msg = '删除';

    //   const data = {
    //     params: ids,
    //     url,
    //     title,
    //     msg,
    //   };
    //   this.messageBox(data);
    // },
  },
  created() {
    this.getConfigList('specialty_store_list');
  },
};
</script>
